import LinearProgress from "@mui/material/LinearProgress";
import { useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { AuthShell } from "../register/auth-shell";
import "../register/auth-ui.css";
import { showOrToast } from "../shared_modules/ui/components/atoms/or-toast/or-toast";
import { useWorkerRepository } from "./useWorkerRepository";
import WorkerPasswordValidator from "./WorkerPasswordValidator";

export default function WorkerValidator() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { validateWorker } = useWorkerRepository();

  const token = searchParams.get("token");
  const isNew = searchParams.get("isNew");

  useEffect(() => {
    if (!isNew && token) {
      validate({ token: token });
    }
  }, [isNew, token]);

  const done = (data) => {
    validate({
      token: token,
      password: data.password,
    });
  };

  const validate = async (data) => {
    try {
      let result = await validateWorker(data);
      if (result) {
        showOrToast("¡Usuario validado!");
        navigate("/login");
      } else {
        showOrToast("No hemos podido validar el usuario", { type: "error" });
        navigate("/login");
      }
    } catch (error) {
      showOrToast("Error al validar el usuario", { type: "error" });
      navigate("/login");
    }
  };

  return (
    <AuthShell
      title={isNew === "1" ? "Configura tu cuenta" : "Validando tu cuenta"}
      subtitle={
        isNew === "1"
          ? "Por favor, establece una contraseña para completar tu registro."
          : "Estamos confirmando tus credenciales, por favor espera un momento."
      }
      footer={
        <>
          <p className="or-auth-form__hint">
            ¿Ya tienes cuenta? <Link to="/login">Inicia sesión</Link>
          </p>
          <a href="https://openreferences.com/aviso-legal/" target="_blank" rel="noreferrer">
            Términos y Condiciones
          </a>
        </>
      }
    >
      <div className="or-auth-loading">
        {!isNew && <LinearProgress />}
        {isNew === "1" && <WorkerPasswordValidator done={done} />}
      </div>
    </AuthShell>
  );
}
